import { EDisbursementMethod } from "../workers-shared";

export const getCompanyDisbursementMethods = ({
  instantPayEnabled,
  paycardsEnabled,
  reserveEnabled,
}: {
  instantPayEnabled: boolean;
  paycardsEnabled: boolean;
  reserveEnabled: boolean;
}) => [
  {
    value: EDisbursementMethod.DIRECT_DEPOSIT,
    label: "Direct deposit",
  },
  {
    value: EDisbursementMethod.PHYSICAL_CHECK,
    label: "Physical check",
  },
  {
    value: EDisbursementMethod.PREPAID,
    label: "Prepaid",
  },
  {
    value: EDisbursementMethod.DOWNLOAD_CHECK,
    label: "Download check",
  },
  ...(instantPayEnabled
    ? [{ value: EDisbursementMethod.INSTANT_PAY, label: "Instant pay" }]
    : []),
  ...(paycardsEnabled
    ? [{ value: EDisbursementMethod.PAYCARD, label: "Paycard" }]
    : []),
  ...(reserveEnabled
    ? [
        {
          value: EDisbursementMethod.DIRECT_DEPOSIT_SAME_DAY,
          label: "Direct deposit same day",
        },
      ]
    : []),
];
